/**
 * Homepage weekly background themes (comfortable / modern).
 * Cycle (week order): B → C → D → E → F → A → …
 * Anchor week (local Monday of 2026-08-02 week) = B so “now” is Soft Sky.
 */

export const LANDING_THEME_SETS = {
    A: {
        id: "A",
        name: "Sage Mist",
        base: "#c5d5ce",
        mistWash: "#d8e6df",
        mistOrb: "rgba(180, 220, 200, 0.35)",
        mistOrbSoft: "rgba(200, 230, 215, 0.14)",
        shaft: "rgba(220, 245, 230, 0.22)",
        accent: "#3BA666",
    },
    B: {
        id: "B",
        name: "Soft Sky",
        base: "#c8d9e8",
        mistWash: "#dce8f2",
        mistOrb: "rgba(160, 195, 225, 0.38)",
        mistOrbSoft: "rgba(190, 215, 235, 0.16)",
        shaft: "rgba(210, 230, 245, 0.24)",
        accent: "#3d8fd1",
    },
    C: {
        id: "C",
        name: "Fog Stone",
        base: "#d4d8dc",
        mistWash: "#e4e7ea",
        mistOrb: "rgba(170, 180, 190, 0.36)",
        mistOrbSoft: "rgba(200, 208, 216, 0.16)",
        shaft: "rgba(230, 234, 238, 0.28)",
        accent: "#5a6b75",
    },
    D: {
        id: "D",
        name: "Sea Foam",
        base: "#c2ddd6",
        mistWash: "#d7ebe5",
        mistOrb: "rgba(150, 210, 195, 0.36)",
        mistOrbSoft: "rgba(185, 225, 215, 0.16)",
        shaft: "rgba(210, 240, 230, 0.24)",
        accent: "#2f9e8a",
    },
    E: {
        id: "E",
        name: "Pale Sand",
        base: "#e4ddd2",
        mistWash: "#efe9e0",
        mistOrb: "rgba(210, 195, 170, 0.36)",
        mistOrbSoft: "rgba(230, 220, 200, 0.16)",
        shaft: "rgba(245, 238, 225, 0.28)",
        accent: "#8a7a62",
    },
    F: {
        id: "F",
        name: "Soft Lilac Mist",
        base: "#d5d2e0",
        mistWash: "#e6e3ef",
        mistOrb: "rgba(185, 175, 210, 0.36)",
        mistOrbSoft: "rgba(210, 205, 230, 0.16)",
        shaft: "rgba(230, 225, 245, 0.26)",
        accent: "#6b6a9e",
    },
};

/** Weekly order starting with B (current), then C → D → E → F → A. */
export const LANDING_THEME_WEEK_ORDER = ["B", "C", "D", "E", "F", "A"];

/** Local Monday of the week that should show set B (week of 2026-08-02). */
const THEME_ANCHOR_MONDAY = new Date(2026, 6, 27); // Jul 27, 2026

const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

function startOfLocalMonday(date) {
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const day = d.getDay(); // 0 = Sun
    const diff = day === 0 ? -6 : 1 - day;
    d.setDate(d.getDate() + diff);
    d.setHours(0, 0, 0, 0);
    return d;
}

/**
 * @param {Date} [date]
 * @returns {{ id: string, name: string, base: string, mistWash: string, mistOrb: string, mistOrbSoft: string, shaft: string, accent: string }}
 */
export function getLandingWeeklyTheme(date = new Date()) {
    const weekStart = startOfLocalMonday(date);
    const anchor = startOfLocalMonday(THEME_ANCHOR_MONDAY);
    const weeks = Math.floor((weekStart.getTime() - anchor.getTime()) / WEEK_MS);
    const n = LANDING_THEME_WEEK_ORDER.length;
    const index = ((weeks % n) + n) % n;
    const id = LANDING_THEME_WEEK_ORDER[index];
    return LANDING_THEME_SETS[id] || LANDING_THEME_SETS.B;
}
